'use client';
import Plaintext from "./Plaintext.js";
export default Plaintext;